import JSONRPC from './JSONRPC';
import remoteSupportActions from '../redux/reducers/RemoteSupport';
import type { JsonRpcTransport } from './types/JSONRPCAPI';
import type {
  RemoteSupportAvailableResponse,
  RemoteSupportQtObject,
  RemoteSupportOpenResponse,
  RemoteSupportRunningResponse,
  RemoteSupportStore,
} from './types/RemoteSupport';

export type {
  RemoteSupportAvailableResponse,
  RemoteSupportQtObject,
  RemoteSupportOpenResponse,
  RemoteSupportRunningResponse,
  RemoteSupportStore,
} from './types/RemoteSupport';

function createNullJsonRpc(): JsonRpcTransport {
  return {
    request: <T = unknown>() => Promise.resolve(null as T),
    handleResponse: () => undefined,
  };
}

export class RemoteSupportAPI {
  private jsonrpc: JsonRpcTransport;

  // dummy dispatcher that resolves all calls to null
  constructor() {
    // dummy dispatcher that resolves all calls to null
    this.jsonrpc = createNullJsonRpc();
  }

  connect(qtobject: RemoteSupportQtObject | null, store: RemoteSupportStore) {
    // connecting all machine actions here
    try {
      if (qtobject) {
        this.jsonrpc = new JSONRPC((message) =>
          qtobject.dispatch(JSON.stringify(message))
        );
        qtobject.response.connect((str: string) =>
          this.jsonrpc.handleResponse(JSON.parse(str))
        );
      }

      store.dispatch(remoteSupportActions.checkIsRemoteSupportAvailable());
    } catch (e) {
      console.log(e);
      this.jsonrpc = createNullJsonRpc();
    }
  }

  openTeamviewer(): Promise<RemoteSupportOpenResponse> {
    return this.jsonrpc.request<RemoteSupportOpenResponse>('open_teamviewer');
  }

  isRunning(): Promise<RemoteSupportRunningResponse> {
    return this.jsonrpc.request<RemoteSupportRunningResponse>('is_running');
  }

  isRemoteSupportAvailable(): Promise<RemoteSupportAvailableResponse> {
    return this.jsonrpc.request<RemoteSupportAvailableResponse>(
      'is_remote_support_available'
    );
  }
}
const api = new RemoteSupportAPI();

export { api as default };
